function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

require("core-js/modules/es.array.sort.js");

// See https://www.wikidata.org/w/api.php?action=help&modules=query%2Bsearch
var _require = require('../utils/utils'),
    isPlainObject = _require.isPlainObject;

var namespacePattern = /^\d+[|\d]*$/;

module.exports = function (buildUrl) {
  return function (params) {
    if (!isPlainObject(params)) {
      throw new Error("expected parameters to be passed as an object, got ".concat(params, " (").concat(typeof params, ")"));
    }

    var search = params.search,
        haswbstatement = params.haswbstatement,
        _params$format = params.format,
        format = _params$format === void 0 ? 'json' : _params$format,
        limit = params.limit,
        offset = params.offset,
        profile = params.profile,
        sort = params.sort;
    var namespace = params.namespace;
    if (!(search || haswbstatement)) throw new Error('missing "search" or "haswbstatement" parameter');
    var srsearch = '';
    if (search) srsearch += search;

    if (haswbstatement) {
      var statements = haswbstatement instanceof Array ? haswbstatement : [haswbstatement];

      var _iterator = _createForOfIteratorHelper(statements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var statement = _step.value;
          if (statement[0] === '-') srsearch += " -haswbstatement:".concat(statement.slice(1));else srsearch += " haswbstatement:".concat(statement);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }

    if (limit != null && (typeof limit !== 'number' || limit < 1)) {
      throw new Error("invalid limit: ".concat(limit));
    }

    if (offset != null && (typeof offset !== 'number' || offset < 0)) {
      throw new Error("invalid offset: ".concat(offset));
    }

    if (namespace instanceof Array) namespace = namespace.join('|');else if (typeof namespace === 'number') namespace = namespace.toString();

    if (namespace && !namespacePattern.test(namespace)) {
      throw new Error("invalid namespace: ".concat(namespace));
    }

    if (profile != null && typeof profile !== 'string') {
      throw new Error("invalid profile: ".concat(profile, " (").concat(typeof profile, ", expected string)"));
    }

    if (sort != null && typeof sort !== 'string') {
      throw new Error("invalid sort: ".concat(sort, " (").concat(typeof sort, ", expected string)"));
    }

    return buildUrl({
      action: 'query',
      list: 'search',
      srsearch: srsearch.trim(),
      format: format,
      srnamespace: namespace,
      srlimit: limit,
      sroffset: offset,
      srqiprofile: profile,
      srsort: sort
    });
  };
};